import baseEn from '@gasbi/localizations/en.json';
import baseUa from '@gasbi/localizations/ua.json';

import ActValidationCode_en from './__mocks__/ActValidationCode_en.json';
import ActValidationCode_ua from './__mocks__/ActValidationCode_ua.json';
import BuildingProfileIndicatorValidationCode_en from './__mocks__/BuildingProfileIndicatorValidationCode_en.json';
import BuildingProfileIndicatorValidationCode_ua from './__mocks__/BuildingProfileIndicatorValidationCode_ua.json';
import ConnectedCapacity_en from './__mocks__/ConnectedCapacity_en.json';
import ConnectedCapacity_ua from './__mocks__/ConnectedCapacity_ua.json';
import ConsumptionGroup_en from './__mocks__/ConsumptionGroup_en.json';
import ConsumptionGroup_ua from './__mocks__/ConsumptionGroup_ua.json';
import Month_en from './__mocks__/Month_en.json';
import Month_ua from './__mocks__/Month_ua.json';
import overridesEn from './__mocks__/en.json';
import overridesUa from './__mocks__/ua.json';

export const LOCALE_NS = 'privateConsumers';

const ua = {
  ...baseUa,
  ...overridesUa,
  ...ActValidationCode_ua,
  ...ConsumptionGroup_ua,
  ...Month_ua,
  ...BuildingProfileIndicatorValidationCode_ua,
  ...ConnectedCapacity_ua,
};
const en = {
  ...baseEn,
  ...overridesEn,
  ...ActValidationCode_en,
  ...ConsumptionGroup_en,
  ...Month_en,
  BuildingProfileIndicatorValidationCode_en,
  ...ConnectedCapacity_en,
};

export const locales = {
  ua: { [LOCALE_NS]: ua },
  en: { [LOCALE_NS]: en },
};

const lng = 'ua';

const supportedLangs = ['ua', 'en'];
const fallbackLng = 'en';
const defaultNS = LOCALE_NS;

export const i18nInstanceOptions = {
  locales,
  lng,
  supportedLangs,
  fallbackLng,
  defaultNS,
};
